import React from 'react';
import { useAPIContext } from '../../../context/api';
import { BrandsAPI } from '../../../../../constructs/brands/interface';

export const useInitializeBanner = () => {
  const { callEndpoint } = useAPIContext();

  const initializeBanner = React.useCallback(async (): Promise<string> => {
    try {
      const res = await callEndpoint<BrandsAPI, 'initialize-banner'>('brands', '/banners/initialize', 'POST');

      if (!res || !res.bannerId) {
        throw new Error('Failed to initialize banner: no bannerId returned');
      }

      return res.bannerId;
    } catch (error) {
      console.error('Error initializing banner:', error);
      throw error;
    }
  }, [callEndpoint]);

  return { initializeBanner };
};
